import React from "react";
import { Navigate } from "react-router-dom";
import { getDecryptedUserFromCookie } from "./utils/getCookie";

/** Blocks users with type Staff from admin-only pages (e.g. settings). */
function AdminOnlyRoute({ children }) {
  const user = getDecryptedUserFromCookie();
  if (String(user?.type ?? "").toLowerCase() === "staff") {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default AdminOnlyRoute;
